import React from 'react';

import classNames from 'classnames';

import styles from './Typography.module.css';

export type TypographySize = 'l' | 'm' | 's';

export type TypographVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'body1'
  | 'body2'
  | 'bodySubText1'
  | 'bodySubText2'
  | 'subText1';

export enum TypographyColor {
  Accent = 'accent',
  Error = 'error',
  LinkPrimary = 'linkPrimary',
  Pink = 'pink',
  Primary = 'primary',
  Quaternary = 'quaternary',
  Quinary = 'quinary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  TopBlock = 'topBlock',
  TopBlockDescription = 'topBlockDescription',
  Warning = 'warning',
  White = 'white',
}

export type Props = {
  children: React.ReactNode;
  className?: string;
  color?: TypographyColor;
  component?: string;
  dataTau?: string;
  onClick?: () => void;
  size?: TypographySize;
  style?: React.CSSProperties;
  variant?: TypographVariant;
};

const variantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  body1: 'p',
  body2: 'p',
  bodySubText1: 'p',
  bodySubText2: 'p',
  subText1: 'p',
};

export const Typography = React.memo(
  ({
    variant = 'body1',
    onClick,
    className,
    component,
    children,
    size,
    style,
    color = TypographyColor.Primary,
    dataTau,
  }: Props) => {
    const Component = (component || variantMapping[variant]) as keyof JSX.IntrinsicElements;

    return (
      <Component
        className={classNames(
          styles.root,
          styles[variant],
          className,
          { [styles.noWrap]: CONFIG.isHyphenation },
          size && styles[size],
          styles[color],
        )}
        style={style}
        onClick={onClick}
        data-tau={dataTau}
      >
        {children}
      </Component>
    );
  },
);

Typography.displayName = 'Typography';
